export default function LoginIcon() {
  return <svg width="20" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.0350216 16.2173C-0.166855 17.1824 0.533613 18 1.37576 18H12.5L12 16.5C11.5 14.5 12.5 12 14.7067 11C13.1305 9.75041 11.1379 9 9 9C4.64527 9 0.893413 12.1135 0.0350216 16.2173Z"
      fill="white"/>
    <path
      d="M9 8C11.2091 8 13 6.20914 13 4C13 1.79086 11.2091 0 9 0C6.79086 0 5 1.79086 5 4C5 6.20914 6.79086 8 9 8Z"
      fill="white"/>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.5 19.7778C18.8626 19.7778 20.7778 17.8626 20.7778 15.5C20.7778 13.1374 18.8626 11.2222 16.5 11.2222C14.1374 11.2222 12.2222 13.1374 12.2222 15.5C12.2222 17.8626 14.1374 19.7778 16.5 19.7778ZM16.5 21C19.5376 21 22 18.5376 22 15.5C22 12.4624 19.5376 10 16.5 10C13.4624 10 11 12.4624 11 15.5C11 18.5376 13.4624 21 16.5 21Z"
      fill="white"/>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.5 15.5C13.5 15.2239 13.7239 15 14 15H19C19.2761 15 19.5 15.2239 19.5 15.5C19.5 15.7761 19.2761 16 19 16H14C13.7239 16 13.5 15.7761 13.5 15.5Z"
      fill="white"/>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.5 18.5C16.2239 18.5 16 18.2761 16 18L16 13C16 12.7239 16.2239 12.5 16.5 12.5C16.7761 12.5 17 12.7239 17 13L17 18C17 18.2761 16.7761 18.5 16.5 18.5Z"
      fill="white"/>
  </svg>

}
